import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import chapterService from "@/services/api/chapters";
import type { Chapter, GetChaptersParams } from "@/services/api/chapters";

export interface ChapterState {
  chapters: Chapter[];
  totalChapters: number;
  isFetching: boolean;
  error: string | null;
}

const initialState: ChapterState = {
  chapters: [],
  totalChapters: 0,
  isFetching: false,
  error: null,
};

export const getChapters = createAsyncThunk(
  "chapter/getChapters",
  async (params: GetChaptersParams | undefined) => chapterService.getChapters(params),
);

const chapterSlice = createSlice({
  name: "chapter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChapters.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(getChapters.fulfilled, (state, action) => {
        state.isFetching = false;
        state.chapters = action.payload?.data?.results ?? [];
        state.totalChapters = action.payload?.data?.totalRecord ?? state.chapters.length;
      })
      .addCase(getChapters.rejected, (state, action) => {
        state.isFetching = false;
        state.chapters = [];
        state.error = action.error.message ?? "Failed to load chapters";
      });
  },
});

export default chapterSlice.reducer;
